import { Outlet } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ACCESS_CONFIG, NESTED_SIDENAV, TEMPLATES } from "../strings";
import NestedTabsComponent from "../nested-tabs-component";

const TemplateLayout = () => {
  const { t } = useTranslation();
  const { ADMIN_TIER, ONLY_SUPER_ADMIN, MARKETING_MANAGER_TIER } =
    ACCESS_CONFIG;

  return (
    <div className="d-flex h-100">
      <div className="sub-sidebar">
        <div className="inner-sub-sidebar">
          <div className="tab-heading ps-3 mt-4">{t("sidebar.templates")}</div>
          <NestedTabsComponent
            nestedNavType={NESTED_SIDENAV.TEMPLATE}
            tabs={[
              {
                evKey: TEMPLATES.FUNNEL_TEMPLATE,
                title: t("sidebar.funnelTemplates"),
                access: MARKETING_MANAGER_TIER
              },
              {
                evKey: TEMPLATES.GLOBAL_THANK_YOU_TEMPLATE,
                title: t("sidebar.globalThankYouTemplate"),
                access: ONLY_SUPER_ADMIN
              },
              {
                evKey: TEMPLATES.PRIVACY_CONSENT,
                title: t("privacyPolicy.tabName"),
                access: ADMIN_TIER
              }
            ]}
          />
        </div>
      </div>
      <div className="outlet-wrapper">
        <Outlet />
      </div>
    </div>
  );
};
export default TemplateLayout;
